import React from 'react';
import './Calendar.css';

const CAL_SRC = "https://www.google.com/calendar/embed?mode=AGENDA&height=600&wkst=1&bgcolor=%23FFFFFF&src=pfclfrurjntp04er2r66ll4b0g%40group.calendar.google.com&color=%23182C57&ctz=America%2FNew_York";

function Calendar() {
  return (
    <section className="page-section calendar-page">
      <div className="section-header">
        <p className="section-eyebrow">Live Dates</p>
        <h2 className="section-title">Shows &amp; Schedule</h2>
        <div className="gold-rule" />
      </div>

      <div className="calendar-wrap">
        <iframe
          title="Mike Mallick Show Calendar"
          src={CAL_SRC}
          scrolling="no"
        />
      </div>
    </section>
  );
}

export default Calendar;
